import { HelpOutline } from "@mui/icons-material";
import { Box, Button, SvgIconProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { globalStyles } from "../styles/GlobalStyles";
import { ComponentType, FC } from "react";

interface EmptyComponentProps {
  title?: string;
  icon?: ComponentType<SvgIconProps>;
  iconColor?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

const EmptyComponent: FC<EmptyComponentProps> = ({
  title,
  icon: Icon = HelpOutline,
  iconColor = "custom.foreground.inactive",
  onRetry,
  retryLabel,
}) => {
  const { t } = useTranslation();
  return (
    <Box sx={globalStyles.colCenter}>
      <Icon sx={{ fontSize: 96, color: iconColor }} />
      <Typography
        my="2rem"
        fontWeight={700}
        fontSize="2rem"
        color={iconColor}
        textAlign="center"
      >
        {t(title ?? "No_graph_to_display")}
      </Typography>
      {onRetry && (
        <Button
          variant="outlined"
          onClick={onRetry}
          sx={{ textTransform: "none", borderColor: "custom.border", borderRadius: 3, mt: -1, mb: 3 }}
        >
          {t(retryLabel ?? "Retry")}
        </Button>
      )}
    </Box>
  );
};

export default EmptyComponent;
